export enum MessageConfigEnum {
    STAFF_PRICING = 'staff.pricing',
    STAFF_CONSULT = 'staff.consult',
}
